import React from 'react';

const Header = props => (
  <div className={`box-head ${props.className || ''}`}>
    <h2>{props.title}</h2>
    { props.subtitle && (
      <h3>
        {props.subtitle}
      </h3>
    ) }
  </div>
);

export default Header;
